<script>
import { mapActions, mapState } from 'vuex';
import mainViewTabMixin from '../../mixins/mainViewTab';
import paginationMixin from '../../mixins/pagination';
import DepartmentListItem from './components/DepartmentListItem';
import NewDepartmentDialog from './components/NewDepartmentDialog';
import RbxConfirmDialog from '../../shared/reybex/RbxConfirmDialog';

export default {
  name: 'DepartmentList',
  components: {
    DepartmentListItem,
    NewDepartmentDialog,
    RbxConfirmDialog,
  },
  mixins: [mainViewTabMixin, paginationMixin],
  data() {
    return {
      isInitialized: false,
      headers: [{ text: 'Name', value: 'name' }, { text: 'Gelöscht', value: 'isDelete' }, { text: 'Aktionen', value: '', sortable: false }],
      showNewDepartmentDialog: false,
      isConfirmDialogDisplayed: false,
      confirmDeletionMessage: '',
      departmentToDelete: {},
      isDeleteFilter: false,
      isDeleteOptions: [{ id: null, text: 'alle' }, { id: true, text: 'ja' }, { id: false, text: 'nein' }],
    };
  },
  computed: {
    ...mapState(['departmentList']),
    ...mapState('departmentList', ['data', 'meta', 'isLoading', 'hasError']),
    filteredItems() {
      const self = this;

      if (!this.data) return [];
      if (this.isDeleteFilter == null) return this.data;

      return this.data.filter(it => it.isDelete === self.isDeleteFilter);
    },
  },
  mounted() {
    this.fetchData(this.paginationParams);
    this.isInitialized = true;
  },
  methods: {
    ...mapActions('departmentList', ['fetchDepartmentList']),
    ...mapActions('departmentList', { deleteDepartment: 'deleteDepartment' }),
    fetchData(options) {
      return this.fetchDepartmentList(options);
    },
    onDelete(departmentToDelete) {
      this.departmentToDelete = departmentToDelete;
      this.confirmDeletionMessage =
        `Soll die Abteilung ${this.departmentToDelete.name} gelöscht werden?`;
      this.isConfirmDialogDisplayed = true;
    },
    onRefuse() {
      this.isConfirmDialogDisplayed = false;
    },
    onConfirm() {
      this.deleteDepartment(this.departmentToDelete)
        .then(() => {
          this.fetchData().then(() => {
            this.isInitialized = true;
          });
          this.isConfirmDialogDisplayed = false;
        });
    },
  },
};
</script>

<template>
  <div class="department-list">
    <template v-if="departmentList.hasError">
      <p class="js-error-template ma-3">Failed to fetch department list. Please try again!</p>
    </template>
    <template v-else>
      <v-toolbar dark dense height="40" color="blue-grey lighten-2">
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="showNewDepartmentDialog = true">
            <v-icon>add</v-icon>
          </v-btn>
          <span>Hinzufügen</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn @click="fetchData" icon slot="activator">
            <v-icon>refresh</v-icon>
          </v-btn>
          <span>Aktualisieren</span>
        </v-tooltip>
      </v-toolbar>

      <template>
        <v-flex xs4 md2>
          <v-select
            style="padding-left: 22px; padding-top: 25px;"
            :items="isDeleteOptions"
            v-model="isDeleteFilter"
            item-value="id"
            item-text="text"
            label="Gelöscht" />
        </v-flex>
      </template>

      <v-progress-linear
        v-if="departmentList.isLoading && !isInitialized"
        :indeterminate="true"
        class="js-loading ma-0"
      />

      <v-data-table
        v-else
        :headers="headers"
        :items="filteredItems"
        :disable-initial-sort="true"
        :pagination="pagination"
        :loading="departmentList.isLoading"
        :rows-per-page-items="rowsPerPageItems"
        :total-items="this.pagination.totalItems"
        :expand="true"
        item-key="id"
        @update:pagination="loadNextPage"
        rows-per-page-text="Zeilen pro Seite"
        no-data-text="keine Daten verfügbar"
        class="elevation-1 js-table"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column sortable',
                       pagination.descending ? 'desc' : 'asc',
                       header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value, data)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>

        <template slot="items" slot-scope="props">
          <department-list-item
            :department="props.item"
            :expanded="props.expanded"
            @delete="onDelete"
          />
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
          von {{ pageStart }} bis {{ pageStop }}
        </template>
      </v-data-table>

      <NewDepartmentDialog
        v-if="showNewDepartmentDialog"
        @cancel="showNewDepartmentDialog = false"
      />

      <rbx-confirm-dialog @confirm="onConfirm" @refuse="onRefuse"
                          :message="confirmDeletionMessage"
                          :is-displayed="isConfirmDialogDisplayed" />

    </template>
  </div>
</template>

<style lang="scss" scoped>
.variant-cell {
  width: 30px;

  i {
    cursor: pointer;
  }
}
</style>
